// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__IPL3H","actions":"GroupTable_actions__mH0Du","deleteModalFooter":"GroupTable_deleteModalFooter__CYmVB"};